import { ft } from '~/utils/feature-translate';

export const StatisticsRu = {
  sidebar: {
    title: 'Статистика',
    client_auth: 'Авторизации клиентов',
  },
  page: {
    title: 'Статистика',
    subtitle: 'Авторизации и регистрации клиентов',
  },
  table: {
    metric: 'Показатель',
  },
  periods: {
    today: 'Сегодня',
    yesterday: 'За вчера',
    week: 'За 7 дней',
    month: 'За 30 дней',
  },
  metrics: {
    new_registrations: 'Новые регистрации',
    new_registrations_hint: 'Кол-во новых клиентов, зарегистрировавшихся в период',
    unique_logins: 'Уникальные авторизации',
    unique_logins_hint: 'Кол-во уникальных клиентов, входивших в приложение',
    total_logins: 'Всего авторизаций',
    total_logins_hint: 'Общее число входов (с учётом повторных)',
    returning_logins: 'Возвратные авторизации',
    returning_logins_hint: 'Уникальные клиенты, которые уже были зарегистрированы ранее',
  },
  filters: {
    period_label: 'Произвольный период',
    period_placeholder_start: 'Дата начала',
    period_placeholder_end: 'Дата конца',
    range_separator: 'по',
    reset: 'Сбросить',
  },
  errors: {
    load: 'Не удалось загрузить статистику',
  },
};

export const t = ft(StatisticsRu, 'statistics.');
